module.exports = __webpack_public_path__ + "img/p3_title.639c5c24.png";